import React from 'react';
import './styles.css';

const ProjectLoading = () => {
  return (
    <div className="container">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ProjectLoading;
